// Manufacturer / carbon-brand hub data.
// IMPORTANT: `name` MUST exactly match the product `brand` field in products.json
// so BrandHub can filter products correctly.

export const BRANDS = [
  {
    slug: 'sooqoo-carbon',
    name: 'Sooqoo Carbon',
    logo: '/assets/brand-logos/sooqoo.png',
    kicker: 'Pre-Preg Dry Carbon Fiber',
    title: 'Sooqoo Carbon — Dry Carbon Fiber Body Kits',
    metaDescription:
      'Shop the full Sooqoo Carbon range at Fortune Auto Design — pre-preg dry carbon fiber front lips, spoilers, diffusers, canards and full body kits with precision OEM fitment. Made-to-order, shipped across Canada & worldwide.',
    intro: [
      'Sooqoo Carbon is a specialist manufacturer of pre-preg (autoclave-cured) dry carbon fiber aerodynamic parts, engineered for precise OEM-level fitment and a flawless deep-gloss twill weave.',
      'Fortune Auto Design carries the complete Sooqoo Carbon catalogue for premium European and performance chassis — front lips, side skirts, rear diffusers, spoilers, canards and full body kits — each piece made-to-order and shipped across Canada and worldwide.',
    ],
    highlights: [
      'Pre-preg dry carbon (autoclave-cured) for strength and a deep-gloss weave',
      'Precision OEM fitment, engineered per chassis',
      'Full body kits and individual aero pieces',
      'Made-to-order · shipped across Canada & worldwide',
    ],
  },
  {
    slug: 'paktechz',
    name: 'Paktechz',
    logo: '/assets/brand-logos/paktechz.png',
    kicker: 'Precision Dry Carbon Aero',
    title: 'Paktechz Carbon Fiber Body Kits & Aero',
    metaDescription:
      'The complete Paktechz dry carbon fiber collection at Fortune Auto Design — hoods, front lips, diffusers, spoilers and widebody kits for BMW, Mercedes-AMG, Porsche, Audi, Ferrari, Lamborghini and more. Made-to-order in Canada.',
    intro: [
      'Established in 2016, Paktechz is renowned for tournament-grade dry carbon fiber body kits with race-inspired design and meticulous surface finish.',
      'At Fortune Auto Design you can shop the full Paktechz range — dry carbon hoods, front lips, rear diffusers, spoilers, mirror caps and complete widebody kits — engineered for OEM fitment across the world\u2019s most iconic performance cars.',
    ],
    highlights: [
      'Established 2016 · race-inspired dry carbon design',
      'Hoods, lips, diffusers, spoilers & full widebody kits',
      'OEM-precise fitment for European & exotic chassis',
      'Made-to-order · shipped across Canada & worldwide',
    ],
  },
  {
    slug: 'darwinpro-aerodynamics',
    name: 'DarwinPro Aerodynamics',
    logo: '/assets/brand-logos/darwinpro.png',
    kicker: 'Design-Led Carbon Aero',
    title: 'DarwinPro Aerodynamics Carbon Body Kits',
    metaDescription:
      'Shop DarwinPro Aerodynamics carbon fiber body kits at Fortune Auto Design — bold IMP & Tuning-series aero, front lips, diffusers, spoilers and full kits for BMW, Tesla, Mercedes, Porsche and more. Made-to-order in Canada.',
    intro: [
      'DarwinPro Aerodynamics is known for bold, design-forward carbon fiber body kits and complete aero programs, including its popular IMP and Tuning-series styling.',
      'Fortune Auto Design offers the DarwinPro range for a wide selection of performance and EV chassis — front lips, rear diffusers, spoilers and full-body conversions — all made-to-order and shipped worldwide.',
    ],
    highlights: [
      'Bold, design-forward aero programs (IMP & Tuning series)',
      'Carbon fiber lips, diffusers, spoilers & full kits',
      'Fitment for performance & EV chassis',
      'Made-to-order · shipped across Canada & worldwide',
    ],
  },
  {
    slug: 'karbel-carbon',
    name: 'Karbel Carbon',
    logo: '/assets/brand-logos/karbel.png',
    kicker: 'Dry Carbon Aero',
    title: 'Karbel Carbon Fiber Body Kits & Aero',
    metaDescription:
      'Shop Karbel Carbon dry carbon fiber aero at Fortune Auto Design — front lips, side skirts, diffusers and spoilers with precise fitment for Audi, BMW and more. Made-to-order, shipped across Canada & worldwide.',
    intro: [
      'Karbel Carbon produces clean, OEM-style dry carbon fiber aerodynamic upgrades designed to enhance your car\u2019s lines without going overboard.',
      'Browse the Karbel Carbon collection at Fortune Auto Design — front lips, side skirts, rear diffusers and spoilers — each made-to-order with precise, chassis-specific fitment.',
    ],
    highlights: [
      'OEM-style dry carbon aerodynamic upgrades',
      'Front lips, side skirts, diffusers & spoilers',
      'Precise chassis-specific fitment',
      'Made-to-order · shipped across Canada & worldwide',
    ],
  },
  {
    slug: 'takd-carbon',
    name: 'Takd Carbon',
    logo: '/assets/brand-logos/takd.png',
    kicker: 'Dry Carbon Aero',
    title: 'Takd Carbon Fiber Body Kits & Aero',
    metaDescription:
      'Shop Takd Carbon dry carbon fiber aero parts at Fortune Auto Design — precision front lips and styling upgrades with OEM fitment. Made-to-order, shipped across Canada & worldwide.',
    intro: [
      'Takd Carbon crafts precision dry carbon fiber aerodynamic parts with a focus on clean fitment and a premium weave finish.',
      'Explore the Takd Carbon range at Fortune Auto Design — made-to-order and shipped worldwide, with fitment engineered for your exact chassis.',
    ],
    highlights: [
      'Precision dry carbon fiber styling',
      'Premium twill weave finish',
      'OEM-precise, chassis-specific fitment',
      'Made-to-order · shipped across Canada & worldwide',
    ],
  },
  {
    slug: 'fortune',
    name: 'Fortune',
    logo: '/assets/shopify-migrated/Fortune_Logo_White-add8ef8898a01d65.png',
    kicker: 'Forged Wheels & Aero',
    title: 'Fortune — Forged Wheels, Body Kits & Aero',
    metaDescription:
      'Shop Fortune\u2019s own range at Fortune Auto Design \u2014 bespoke Fortune Forged wheels plus Fortune body kits and aero. Made-to-order, shipped across Canada & worldwide.',
    intro: [
      'Fortune is our in-house line \u2014 bespoke Fortune Forged wheels engineered for individuality and performance, alongside Fortune body kits and aero built for precise, race-tested fitment.',
      'Browse every Fortune-branded product in one place \u2014 forged wheels in Monoblock or multi-piece construction plus FRP body kits and aero \u2014 each made-to-order to your spec and shipped across Canada and worldwide.',
    ],
    highlights: [
      'Fortune Forged wheels \u2014 Monoblock (1-piece) & multi-piece',
      'Fortune body kits & aero \u2014 hand-laid FRP, race-tested fitment',
      'Custom fitment, offset & finish to your spec',
      'Made-to-order · shipped across Canada & worldwide',
    ],
    // Fortune's own products span two catalogue brand tags plus the forged
    // wheels collection — include all so nothing disappears.
    brandNames: ['Fortune', 'Fortune Black Label'],
    collectionIds: ['fortune-forged-wheels'],
  },
];

export const getBrandBySlug = (slug) => BRANDS.find((b) => b.slug === slug);
export const getBrandForName = (name) => BRANDS.find((b) => b.name === name);
